import React from "react";
import { TextField, MenuItem } from "@mui/material";

const LocationDetailsSection = ({
  city,
  province,
  country,
  provinces,
  onChange,
}) => (
  <>
    <TextField
      label="City"
      value={city}
      onChange={(e) => onChange("city", e.target.value)}
      fullWidth
    />
    <TextField
      select
      label="US State"
      value={province}
      onChange={(e) => onChange("province", e.target.value)}
      fullWidth
    >
      {provinces.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
    <TextField
      label="Country"
      value={country}
      onChange={(e) => onChange("country", e.target.value)}
      fullWidth
    />
  </>
);

export default LocationDetailsSection;
